var _path, _path2, _polygon, _polygon2, _polygon3, _polygon4, _path3, _polygon5, _polygon6, _path4, _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcons8FinalCutProX(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#cfd8dc",
    d: "M42.17,40.159l-24.004,3.754l-6.656,1.045c-1.831,0.288-3.555-0.934-3.846-2.731L3.573,17.118 l37.293-5.839l4.092,25.108C45.249,38.185,44.001,39.871,42.17,40.159z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M39.552,5.382c-0.512-1.747-2.377-2.755-4.166-2.252L5.443,11.553 c-1.789,0.503-2.824,2.328-2.313,4.075l0.442,1.49L39.994,6.872L39.552,5.382z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#455a64",
    points: "40.87,11.28 36.37,16.4 36.3,16.48 30.96,17.31 31.03,17.24 35.53,12.11"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#455a64",
    points: "30.19,12.95 25.69,18.07 20.35,18.91 24.86,13.78"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#455a64",
    points: "19.47,14.63 14.98,19.75 9.68,20.58 14.18,15.46"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#455a64",
    points: "8.85,16.29 4.36,21.41 4.29,21.49 4.28,21.43 3.57,17.12"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#cfd8dc",
    d: "M39.993,6.873l-7.065-3.052l2.457-0.691c0.313-0.088,0.627-0.127,0.935-0.127 c1.461,0,2.81,0.934,3.23,2.378L39.993,6.873z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#cfd8dc",
    points: "34.792,8.332 29.597,9.798 22.538,6.746 27.728,5.28 27.733,5.28"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#cfd8dc",
    points: "24.397,11.257 19.202,12.723 12.137,9.665 17.338,8.205"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#cfd8dc",
    d: "M14.007,14.182l-5.2,1.465l-5.464-2.366c0.403-0.813,1.142-1.46,2.099-1.731l1.5-0.42L14.007,14.182 z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#64dd17",
    d: "M24.78,30.29l-4.55,10.77l-9.11,1.43c-0.48,0.07-0.92-0.22-0.99-0.67l-0.07-0.44L24.78,30.29z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#1e88e5",
    points: "31.72,39.26 26.06,40.15 24.78,30.29"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ab47bc",
    d: "M42.49,36.79c0.04,0.25-0.05,0.44-0.14,0.56c-0.02,0.04-0.06,0.08-0.12,0.13l-17.45-7.19l16.31-2.08 L42.49,36.79z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#b2ff59",
    points: "24.78,30.29 10.06,41.38 8.59,32.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#00acc1",
    points: "26.06,40.15 20.23,41.06 24.78,30.29"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7c4dff",
    d: "M42.23,37.48c-0.1,0.09-0.24,0.18-0.45,0.21l-10.06,1.57l-6.94-8.97L42.23,37.48z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffea00",
    points: "24.78,30.29 8.59,32.35 7.07,23.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffa726",
    points: "24.777,30.289 17.847,21.321 23.496,20.436"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fdd835",
    points: "24.78,30.29 7.07,23.01 17.847,21.321"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e91e63",
    points: "41.09,28.21 24.78,30.29 39.61,19.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ff7043",
    points: "29.355,19.519 24.777,30.289 23.496,20.436"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f44336",
    points: "39.61,19.11 24.78,30.29 29.36,19.52 39.42,17.94"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#76ff03",
    d: "M18.225,35.228c0.866,1.146,2.017,2.063,3.358,2.63l3.197-7.568L18.225,35.228z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#64b5f6",
    d: "M25.836,38.428c1.483-0.191,2.839-0.775,3.965-1.647L24.78,30.29L25.836,38.428z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ba68c8",
    d: "M32.377,33.42c0.4-0.967,0.623-2.026,0.623-3.137c0-0.35-0.029-0.693-0.072-1.032L24.78,30.29 L32.377,33.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ccff90",
    d: "M16.633,31.327c0.185,1.455,0.749,2.787,1.592,3.902l6.555-4.938L16.633,31.327z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4dd0e1",
    d: "M21.583,37.858c0.983,0.415,2.063,0.645,3.197,0.645c0.359,0,0.71-0.031,1.056-0.075L24.78,30.29 L21.583,37.858z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9575cd",
    d: "M29.802,36.781c1.127-0.872,2.023-2.025,2.575-3.361l-7.597-3.13L29.802,36.781z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffee58",
    d: "M24.777,30.289L24.777,30.289L24.777,30.289l-7.601-3.125c-0.395,0.962-0.616,2.014-0.616,3.119 c0,0.354,0.03,0.701,0.073,1.044l8.147-1.037L24.777,30.289z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb74d",
    d: "M23.717,22.139c-1.482,0.192-2.837,0.777-3.963,1.649l5.023,6.498L23.717,22.139z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffeb3b",
    d: "M19.754,23.788c-1.13,0.876-2.027,2.034-2.578,3.376l7.601,3.125L19.754,23.788z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f06292",
    d: "M24.78,30.29l8.148-1.039c-0.183-1.456-0.747-2.79-1.588-3.906L24.78,30.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff8a65",
    d: "M23.717,22.139l1.06,8.147l0.001,0.001l3.218-7.57c-0.988-0.421-2.075-0.654-3.216-0.654 C24.419,22.063,24.066,22.094,23.717,22.139z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff5252",
    d: "M31.34,25.345c-0.861-1.142-2.007-2.057-3.34-2.626l-3.22,7.571L31.34,25.345z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#baff81",
    d: "M24.78,30.288l-2.054,4.856c-0.866-0.365-1.604-0.951-2.156-1.681L24.78,30.288z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#90caf9",
    d: "M28.006,34.456c-0.722,0.56-1.596,0.934-2.547,1.053l-0.679-5.221L28.006,34.456z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce93d8",
    d: "M30.06,30.28c0,0.713-0.144,1.401-0.399,2.02l-4.881-2.012l5.238-0.671 C30.043,29.839,30.06,30.059,30.06,30.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dbffb1",
    d: "M24.78,30.288l-4.21,3.175c-0.543-0.713-0.908-1.579-1.027-2.513L24.78,30.288z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#80deea",
    d: "M25.459,35.509c-0.221,0.034-0.45,0.051-0.679,0.051c-0.73,0-1.426-0.153-2.054-0.416l2.054-4.856 L25.459,35.509z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b39ddb",
    d: "M29.661,32.3c-0.357,0.857-0.925,1.604-1.655,2.156l-3.226-4.168L29.661,32.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff59d",
    d: "M24.78,30.288l-5.238,0.662c-0.025-0.22-0.042-0.441-0.042-0.67c0-0.713,0.144-1.375,0.399-1.995 L24.78,30.288z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffcc80",
    d: "M24.78,30.288l-3.234-4.185c0.722-0.56,1.596-0.934,2.555-1.053L24.78,30.288z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff176",
    d: "M24.78,30.288l-4.881-2.012c0.348-0.857,0.917-1.604,1.647-2.173L24.78,30.288z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f48fb1",
    d: "M30.018,29.618l-5.238,0.671l4.219-3.183C29.534,27.818,29.899,28.684,30.018,29.618z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffab91",
    d: "M26.851,25.424l-2.071,4.864l-0.679-5.238c0.221-0.033,0.45-0.05,0.679-0.05 C25.519,25,26.215,25.153,26.851,25.424z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff8a80",
    d: "M28.999,27.105l-4.219,3.183l2.071-4.864C27.709,25.789,28.447,26.375,28.999,27.105z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#e5ffc7",
    d: "M24.779,30.29l-0.896,2.112c-0.37-0.156-0.697-0.412-0.932-0.733L24.779,30.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bbdefb",
    d: "M26.18,32.103c-0.313,0.242-0.69,0.405-1.109,0.455l-0.292-2.269L26.18,32.103z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e1bee7",
    d: "M27.069,30.29c0,0.313-0.064,0.605-0.171,0.875l-2.119-0.875l2.269-0.292 C27.061,30.091,27.069,30.19,27.069,30.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e5ffc7",
    d: "M24.779,30.29l-1.828,1.38c-0.242-0.313-0.398-0.69-0.448-1.095L24.779,30.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2ebf2",
    d: "M25.07,32.559c-0.092,0.014-0.192,0.021-0.292,0.021c-0.313,0-0.619-0.064-0.896-0.178l0.896-2.112 L25.07,32.559z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d1c4e9",
    d: "M26.898,31.165c-0.156,0.37-0.405,0.697-0.718,0.939l-1.401-1.814L26.898,31.165z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff9c4",
    d: "M24.779,30.29l-2.276,0.284c-0.014-0.092-0.021-0.185-0.021-0.284c0-0.313,0.064-0.604,0.171-0.875 L24.779,30.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe0b2",
    d: "M24.779,30.29l-1.401-1.814c0.313-0.242,0.69-0.405,1.109-0.455L24.779,30.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff9c4",
    d: "M24.779,30.29l-2.126-0.875c0.156-0.37,0.405-0.697,0.725-0.939L24.779,30.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8bbd0",
    d: "M27.047,29.998l-2.269,0.292l1.828-1.38C26.841,29.223,26.997,29.593,27.047,29.998z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffccbc",
    d: "M25.675,28.178l-0.896,2.112l-0.292-2.269C24.579,28.007,24.679,28,24.779,28 C25.091,28,25.397,28.064,25.675,28.178z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffcdd2",
    d: "M26.606,28.91l-1.828,1.38l0.896-2.112C26.044,28.334,26.364,28.59,26.606,28.91z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8FinalCutProX);
export default __webpack_public_path__ + "static/media/icons8-final-cut-pro-x.8aa8cddade38e7939c258a991ce4f0bf.svg";
export { ForwardRef as ReactComponent };